module.exports = __webpack_public_path__ + "img/og_1_white.32a37ea9.png";